import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import emailjs from 'emailjs-com';

@Component({
  selector: 'app-vessel-onboard-email',
  templateUrl: './vessel-onboard-email.component.html',
  styleUrls: ['./vessel-onboard-email.component.scss']
})
export class VesselOnboardEmailComponent {

  constructor(
    private dialogRef: MatDialogRef<VesselOnboardEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel() {
    this.dialogRef.close(false);
  }

  onProceed() {

    const vesselName = this.data.vessel;

    const templateParams = {
      to_email: 'operations@merakishippingservices.com',
      vessel_name: vesselName,
      message: `🚢 New Vessel Request

Vessel Name: ${vesselName}

Please onboard this vessel in system.`
    };

    emailjs.send(
      'service_zrfx2zl',
      'template_8fq8mrc',
      templateParams,
      'nrA2-lkSeYBoZrVjv'
    ).then(() => {

      // 🔥 close popup + send success
      this.dialogRef.close(true);

    }, (error) => {
      console.error(error);
      this.dialogRef.close(false);
    });
  }
}